// Generated by ReScript, PLEASE EDIT WITH CARE

import Classnames from "classnames";
import * as JsxRuntime from "react/jsx-runtime";
import * as BsCssJs$PrezzeeRibbon from "../../../bindings/BsCss/BsCssJs.bs.js";
import * as Theme__Fonts$PrezzeeRibbon from "../../../theme/Theme__Fonts.bs.js";
import * as Theme__Responsive$PrezzeeRibbon from "../../../theme/Theme__Responsive.bs.js";

var heading = BsCssJs$PrezzeeRibbon.style([
      BsCssJs$PrezzeeRibbon.marginBottom(BsCssJs$PrezzeeRibbon.rem(0.75)),
      BsCssJs$PrezzeeRibbon.media(Theme__Responsive$PrezzeeRibbon.desktop, [
            BsCssJs$PrezzeeRibbon.maxWidth(BsCssJs$PrezzeeRibbon.px(512)),
            BsCssJs$PrezzeeRibbon.marginBottom(BsCssJs$PrezzeeRibbon.rem(1))
          ]),
      BsCssJs$PrezzeeRibbon.selector("h1, h2", [
            Theme__Fonts$PrezzeeRibbon.SofiaPro.family,
            BsCssJs$PrezzeeRibbon.fontSize(BsCssJs$PrezzeeRibbon.px(32)),
            BsCssJs$PrezzeeRibbon.lineHeight(BsCssJs$PrezzeeRibbon.px(40)),
            BsCssJs$PrezzeeRibbon.margin("zero"),
            BsCssJs$PrezzeeRibbon.media(Theme__Responsive$PrezzeeRibbon.desktop, [
                  BsCssJs$PrezzeeRibbon.fontSize(BsCssJs$PrezzeeRibbon.px(50)),
                  BsCssJs$PrezzeeRibbon.lineHeight(BsCssJs$PrezzeeRibbon.px(63))
                ])
          ])
    ]);

var Styles = {
  heading: heading
};

function FullWidthHero__Heading(props) {
  var className = props.className;
  var className$1 = className !== undefined ? className : "";
  return JsxRuntime.jsx("div", {
              children: props.children,
              className: Classnames([
                    heading,
                    className$1
                  ])
            });
}

var make = FullWidthHero__Heading;

export {
  Styles ,
  make ,
}
/* heading Not a pure module */
